<template>
  <div
    class="d-flex flex-column border rounded-2 img-library-item"
    :class="img.isSelect && 'img-active'">
    <div
      @click="isImage && $emit('openGallery')"
      class="image-container"
      style="border-bottom: 1px #d9d9d9 solid; background: #eaecf2; padding: 4px 4px 0 4px;">
      <img
        v-if="!isImage"
        class="more w-100 h-100"
        loading="lazy"
        :src="isImage ? img.url : getFileThumb" />
      <el-image
        v-else
        class="image w-100"
        :src="img.url"
        lazy
        fit="cover"></el-image>
    </div>
    <div class="font-14 fw-400 text-grey700 px-2 pt-2 pb-1 d-flex justify-content-between align-items-center">
      <span
        @click="img.isSelect = !img.isSelect"
        class="trim-text-1-line pointer"
        :class="img.isView ? 'fw-bold' : ''"
        style="max-width: 155px">
        {{ img.name }}
      </span>
      <el-checkbox
        class="checkbox-select-message"
        :value="img.isSelect"
        @change="img.isSelect = !img.isSelect"></el-checkbox>
    </div>
  </div>
</template>

<script>
// import Config from "../lib/Config";
import { getFileExtension } from "../lib/text-utils";

export default {
  props: ["img"],
  data() {
    return {
      name: "",
      contentType: "",
      source: "",
    };
  },
  methods: {
    getNameFile() {
      return this.$http.get("/api/image/" + this.img.id).then((resp) => {
        if (!resp.data) {
          this.source = this.img.url;
          console.log(this.img);

          return;
        }
      });
    },
  },
  computed: {
    isImage() {
      return this.img.type.toLowerCase().includes("image");
    },
    getFileThumb() {
      const extension = getFileExtension(this.img.id.toLowerCase());
      switch (extension) {
        case "m4v":
        case "mp4":
        case "avi":
        case "mkv":
        case "wmv":
        case "flv":
        case "mov":
        case "3gp":
        case "3g2": {
          return "/assets/icon/icon-file-video.svg";
        }
        case "pdf": {
          return "/assets/icon/icon-file-pdf.svg";
        }
        case "zip": {
          return "/assets/icon/icon-file-zip.svg";
        }
        case "doc":
        case "docx":
        case "txt":
        case "odt":
        case "tex":
        case "xml":
        case "html": {
          return "/assets/icon/icon-file-doc.svg";
        }
        case "xlsx":
        case "xls":
        case "xlsm":
        case "xlsb": {
          return "/assets/icon/icon-file-excel.svg";
        }
        default:
          return "/assets/icon/icon-file-doc.svg";
      }
    },
  },
  created() {
    // this.getNameFile();
  },
  mounted() {},
};
</script>

<style >
.image {
  object-fit: cover;
  max-height: 165px;
  min-height: 165px;
  border-radius: 4px 4px 0 0;
  cursor: pointer;
}
.more {
  padding: 32px;
}
</style>